import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/apps/web/layouts/default.vue").then(m => m.default || m))
}